module.exports = __webpack_public_path__ + "static/media/chesca.654538a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/chesca.jpg
// module id = 738
// module chunks = 0